<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Hash Bold" class="d-icon d-icon--hash-bold" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.068 1.396a.938.938 0 0 1 1.864.207l-.218 1.96h1.114l.24-2.167a.938.938 0 0 1 1.864.207l-.218 1.96H10a.937.937 0 1 1 0 1.874H8.506L8.38 6.562H10a.937.937 0 1 1 0 1.875H8.172l-.24 2.167a.937.937 0 1 1-1.864-.208l.218-1.959H5.172l-.24 2.167a.937.937 0 1 1-1.864-.208l.218-1.959H2a.937.937 0 1 1 0-1.875h1.494l.125-1.125H2a.937.937 0 1 1 0-1.875h1.828l.24-2.166ZM4.715 4.3a.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174Zm2.747.226a.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174.501.501 0 0 1-.253.226ZM7.382 7.3a.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174Zm-2.844.174a.5.5 0 0 1-.156-.174.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226Zm.968-2.037L5.38 6.562h1.113l.125-1.125H5.506Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHashBold',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
